// extracted by mini-css-extract-plugin
module.exports = {"root":"SubmitButton_root__1qOzj","withText":"SubmitButton_withText__8Drjn","iconSearch":"SubmitButton_iconSearch__z-KeI","text":"SubmitButton_text__3z9PJ"};